
<div style="overflow: hidden;"> 



<div *ngIf="folio" class="bg-light">
    

      <div  >
        <ngx-extended-pdf-viewer #viewerContainer
      [src]="pdfSource"
      [showToolbar]="false"
      [height]="dimensionH <= 900 ? '70vh':'90vh'" 
      [showPrintButton]="false"
      [showOpenFileButton]="false"
      [showScrollingButton]="false"
      [showPropertiesButton]="false"
      [showRotateButton]="false"
      [showZoomButtons]="false"
      [zoom]="'46%'"
      [backgroundColor]="'#fff'"
      [showBorders]="false"
      (pagesLoaded)="onPagesLoaded($event)"
      [showSidebarButton]="false"
      [showPagingButtons]="false"
      [useBrowserLocale]="true"
        [handTool]="false"
      > 
    </ngx-extended-pdf-viewer>
      </div>

      <div *ngIf="messages.length > 0">
        <a name="" id="" class="btn  btn-flotante  "  [routerLink]="['/SIGED/documentos/folio',folio]" routerLinkActive="router-link-active" role="button">ACEPTAR</a>
    </div>

    <!-- <div class="div-flotante" *ngIf="messages.length > 0">
      
    </div> -->
</div>



<!-- <app-footer></app-footer> -->

</div>